// Modules barrel exports
export * from './auth';
export * from './onboarding';
export * from './payments';
export * from './profile';
// Note: document-*, otp, and uae-pass-details are exported via onboarding barrels

